import apiClient from "@/services/axios";

export async function post(venueId, address) {
  var response = await apiClient.post("/venue/info/address", address, {
    headers: {
      venueId: venueId
    }
  });
  if (response) {
    return response.data;
  }

  throw new Error("Unable to update address.");
}
